<template>
  <div class="channel-overview">
    <div class="overview-title">渠道概览</div>
    <div class="overview-list">
      <div class="item">
        <div class="title">渠道总数</div>
        <p>{{stateData.total}}</p>
      </div>
      <div class="item">
        <div class="title">合作中渠道数</div>
        <p>{{stateData.cooperating}}</p>
      </div>
      <div class="item">
        <div class="title">上周新增渠道数</div>
        <p>{{stateData.weeknew}}</p>
      </div>
      <div class="item">
        <div class="title">本月新增渠道数</div>
        <p>{{stateData.monthnew}}</p>
      </div>
      <div class="item">
        <div class="title">访问量</div>
        <p>{{stateData.view}}</p>
      </div>
      <div class="item">
        <div class="title">下载量</div>
        <p>{{stateData.total}}</p>
      </div>
    </div>
    <c-table
      ref="table"
      :columns="columns"
      url="/projecttime/get"
      :defaultParam="defaultParam"
      :key="key"
      @after-fetch="afterFetch"
      :default-sort = "{prop: 'dataTime.mubiaotime', order: 'descending'}"
      :paging="false"
    >
     <template slot="operate">
        <el-button
        type="primary"
        @click="model={}"
        size="small"
        v-if="permission"
      >新增渠道进度</el-button>

      </template>
      <el-table-column slot="name" label="渠道名" min-width="200">
        <template v-slot="{row}">
         <span :class="row.statusClass">{{row.name}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column slot="channel" label="渠道栏目" show-overflow-tooltip min-width="140">
        <template v-slot="{row}">
          <span v-if="row.first&&tagJson[row.first]">{{tagJson[row.first].label}}{{row.second?`/${tagJson[row.first].children[row.second].label}`:''}}</span>
        </template>
      </el-table-column> -->
       <el-table-column slot="hezuoneirong" label="目标合作内容" width="200">
        <template v-slot="{row}">
          <el-input v-model="row.remark" placeholder="" @blur="changeFn(row,'remark')" v-if="permission"></el-input>
          <div v-else>{{row.remark}}</div>
        </template>
      </el-table-column>
      <el-table-column slot="mubiaotime" label="目标上线时间" width="140" prop="dataTime.mubiaotime" sortable>
        <template v-slot="{row}">
          <div :class="row.statusClass">{{row.dataTime.mubiaotime}}</div>
        </template>
      </el-table-column>
      <el-table-column slot="mubiaotime" label="实际完成时间" width="120">
        <template v-slot="{row, $index}">
          <div v-if="row.dataTime.commit_mubiaotime||!permission">{{row.dataTime.commit_mubiaotime}}</div>
          <el-button
            type="primary"
            @click="finishFn(row,$index)"
            size="mini"
            v-else
          >点击完成</el-button>
        </template>
      </el-table-column>
      <el-table-column slot="responsor" label="负责人" min-width="120">
        <template v-slot="{row}">
          <el-input v-model="row.responsor" placeholder="" @blur="changeFn(row,'responsor')" v-if="permission"></el-input>
          <div v-else>{{row.responsor}}</div>
        </template>
      </el-table-column>

      <el-table-column slot="step" label="拓展进度">
          <el-table-column label="建立联系" width="120">
            <template v-slot="{row}">
              <el-date-picker
                v-if="permission"
                v-model="row.dataTime.lianxitime"
                align="right"
                type="date"
                format='yyyy-MM-dd'
                value-format='yyyy-MM-dd'
                placeholder="请选择时间"
                :picker-options="pickerOptions"
                @change="changeFn(row,'lianxitime')">
              </el-date-picker>
              <div v-else>{{row.dataTime.lianxitime}}</div>
            </template>
          </el-table-column>
          <el-table-column label="意向确认" width="120">
            <template v-slot="{row}">
              <el-date-picker
               v-if="permission"
                v-model="row.dataTime.yixiangtime"
                align="right"
                type="date"
                format='yyyy-MM-dd'
                value-format='yyyy-MM-dd'
                placeholder="请选择时间"
                :picker-options="pickerOptions"
                @change="changeFn(row,'yixiangtime')">
              </el-date-picker>
              <div v-else>{{row.dataTime.yixiangtime}}</div>
            </template>
          </el-table-column>
          <el-table-column label="合作提案" width="120">
            <template v-slot="{row}">
              <el-date-picker
               v-if="permission"
                v-model="row.dataTime.hezuotime"
                align="right"
                type="date"
                format='yyyy-MM-dd'
                value-format='yyyy-MM-dd'
                placeholder="请选择时间"
                :picker-options="pickerOptions"
                @change="changeFn(row,'hezuotime')">
              </el-date-picker>
              <div v-else>{{row.dataTime.hezuotime}}</div>
            </template>
          </el-table-column>
          <el-table-column label="确认方案" width="120">
            <template v-slot="{row}">
               <el-date-picker
                v-if="permission"
                v-model="row.dataTime.querentime"
                align="right"
                type="date"
                format='yyyy-MM-dd'
                value-format='yyyy-MM-dd'
                placeholder="请选择时间"
                :picker-options="pickerOptions"
                @change="changeFn(row,'querentime')">
              </el-date-picker>
              <div v-else>{{row.dataTime.querentime}}</div>
            </template>
          </el-table-column>
           <el-table-column label="商务流程" width="120">
            <template v-slot="{row}">
               <el-date-picker
                v-if="permission"
                v-model="row.dataTime.shangwutime"
                align="right"
                type="date"
                format='yyyy-MM-dd'
                value-format='yyyy-MM-dd'
                placeholder="请选择时间"
                :picker-options="pickerOptions"
                @change="changeFn(row,'shangwutime')">
              </el-date-picker>
              <div v-else>{{row.dataTime.shangwutime}}</div>
            </template>
          </el-table-column>
           <el-table-column label="上线测试" width="120">
            <template v-slot="{row}">
              <el-date-picker
               v-if="permission"
                v-model="row.dataTime.shangxiantime"
                align="right"
                type="date"
                format='yyyy-MM-dd'
                value-format='yyyy-MM-dd'
                placeholder="请选择时间"
                :picker-options="pickerOptions"
                @change="changeFn(row,'shangxiantime')">
              </el-date-picker>
              <div v-else>{{row.dataTime.shangxiantime}}</div>
            </template>
          </el-table-column>
      </el-table-column>
      <el-table-column label="操作" width="60" slot="caozuo" v-if="permission">
        <template v-slot="{row,$index}">
          <el-button
            type="text"
            @click="operate(row, $event,$index)"
          >删除</el-button>
        </template>
      </el-table-column>
    </c-table>
    <edit v-model="model"></edit>
  </div>
</template>

<script>
import { Notification } from 'element-ui'
import CTable from '@/components/common/table'
import Edit from './#overview-edit'
import moment from 'moment'
export default {
  components: { CTable, Edit },
  data() {
    return {
      model: null,
      permission: false,
      defaultParam: {
        system: 'changjing'
      },
      key: Date.now(),
      fields: [
        {
          prop: 'name',
          placeholder: '关键词',
          clearable: true
        }
      ],
      columns: [
        { slot: 'name' },
        { slot: 'hezuoneirong' },
        { slot: 'mubiaotime' },
        { slot: 'responsor' },
        { slot: 'step' },
        { slot: 'caozuo' }
      ],
      // tagJson: {},
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '明天',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周后',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      stateData: {}
    }
  },
  watch: {
    '$route': {
      handler(val, oldVal) {
        if (!oldVal || (oldVal && oldVal.fullPath.includes('changjing/edit_step'))) {
          this.key = Date.now()
        }
      },
      immediate: true
    }
  },

  methods: {
    operate (row, event, index) {
      this.$_confirm({
        name: row.name,
        operate: () =>
          this.$http.post(`projecttime/delete`, {
            id: row.id,
            system: 'changjing'
          }).then(() => {
            this.$refs.table.reload()
          })
      })
    },
    afterFetch(res) {
      this.permission = res.data.previllage !== 1
      res.data.data.forEach(data => {
        const result = {}
        data.projecttime.forEach(time => {
          for (const name in time) {
            if (name.indexOf('time') !== -1 && !result[name]) {
              result[name] = time[name].replace(/[.|\s|0|:|-]+/g, '') ? time[name] : ''
            }
          }
        })
        data.dataTime = JSON.parse(JSON.stringify(result))
        const mubiaotime = new Date(data.dataTime.mubiaotime).getTime()
        const today = new Date().getTime()
        data.statusClass = data.dataTime.commit_mubiaotime ? '' : today >= mubiaotime ? 'red' : 'green'
      })
    },
    getTag(value) {
      const temp = {}
      value.forEach(_value => {
        temp[_value.id] = {
          label: _value.label
        }
        _value.children && _value.children.length && (temp[_value.id].children = this.getTag(_value.children))
      })
      return temp
    },
    changeFn(row, name) {
      if (!row.dataTime[name] && !row[name]) {
        Notification.error({ title: '失败', message: '提交值不能为空' })
        return
      }
      const params = { id: row.id, system: 'changjing' }
      if (name.indexOf('time') !== -1) {
        params.name = name
        params.time = row.dataTime[name]
      } else {
        params.name = name
        params[name] = row[name]
      }

      this.$http.post('/projecttime/add', params)
    },
    finishFn(row, index) {
      const time = moment(new Date()).format('YYYY-MM-DD')
      const params = { id: row.id, system: 'changjing' }
      params.name = 'mubiaotime'
      params.time = time
      this.$http.post('/projecttime/commit', params).then(() => {
        this.$refs.table.data.forEach(data => {
          if (data.id === row.id) {
            data.dataTime.commit_mubiaotime = time
            data.statusClass = ''
          }
        })
      })
    }
  },
  created() {
    this.$http.post('/changjing/state2').then(result => {
      this.stateData = result.data
    })
  }

}
</script>

<style lang="scss">
.channel-overview {
  .el-table_1_column_6{
    text-align:center;
    font-weight: 800;
  }

  .el-tooltip {
    @include ellipsis(100%);
  }
  .red{
    color:#FE2323;
  }
  .green{
    color:#0FCE66;
  }
  .c-table .el-table__body tr:last-of-type td{
    border-right:1px solid #EBEEF5;
  }

  .el-table{
    .el-input__inner{
      border: none;
      padding: 0 5px;
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner{
      width:100%;
    }
    .el-date-editor .el-input__inner{
      padding: 0 0 0 5px;
    }
    .el-input__icon{
      display: none;
    }
    // 底部滚动条
    ::-webkit-scrollbar {
      width: 6px;
      height: 8px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 0;
      border: none;
      background-color: #e0e0e0;
      background-clip: padding-box;
      min-height: 28px;
    }
    ::-webkit-scrollbar-track-piece {
        background-color: #fff;
    }
  }
  .overview-title{
    font-size:16px;
    margin-bottom:20px;
  }
  .overview-list{
    display: flex;
    font-size: 14px;
    padding: 15px 0;
    border: 1px solid #eee;
    margin-bottom:20px;
    .item{
      text-align:right;
      padding-right: 15px;
      flex: 1;
      border-right: 1px solid #eee;
      &:last-child{
        border-right:none;
      }
      &>p{
        margin-top:10px;
        font-size:24px;
      }
    }
  }
}
.channel-desc {
  width: 500px;
}

</style>
